<script lang="ts">
	import * as Card from '#lib/components/ui/card/index.js'
	import type { LineChartRecord, ChainData } from '#lib/models/index.js'
	import { getLineChartMetricMenu, LINE_CHART_METRIC_CONFIG } from '#lib/utils/lineChartMetrics.js'
	import { phg } from '#lib/utils/posthog.js'
	import { chainSchema } from '#lib/utils/schema.js'

	import MetricLineChart from './metric-line-chart.svelte'
	import MetricPicker from './metric-picker.svelte'
	import RangeDropdown from './range-dropdown.svelte'

	let {
		class: className,
		title,
		chains,
		chartData,
		params,
	}: {
		class?: string
		title: string
		chains: ChainData[]
		chartData: LineChartRecord[]
		params: ReturnType<typeof chainSchema.parse>
	} = $props()

	const RANGE_OPTIONS = [
		{ label: '7D', value: 'week' },
		{ label: '30D', value: 'month' },
		{ label: '90D', value: 'quarter' },
	]
</script>

<Card.Root class={className} size="xs">
	<Card.Header>
		<Card.Title class="flex items-center justify-start gap-2">
			{#if chains.length === 1}
				<img
					alt="{chains[0].name} logo"
					crossorigin="anonymous"
					decoding="async"
					fetchpriority="low"
					height="28"
					loading="lazy"
					src="https://res.cloudinary.com/dcruwhddg/image/upload/icons/{chains[0].slug}.svg"
					width="28"
				/>
			{/if}

			<h2>
				{title}
				{LINE_CHART_METRIC_CONFIG[params['type-tc']].name()} Chart
			</h2>
		</Card.Title>

		<Card.Action
			class="col-start-1 row-span-1 row-start-2 flex items-center justify-start gap-2 self-start justify-self-start sm:col-start-2 sm:row-span-2 sm:row-start-1 sm:justify-self-end"
		>
			<MetricPicker
				metrics={getLineChartMetricMenu(chains)}
				onValueChange={value => phg.capture('line_chart_type_click', { value })}
				bind:metric={params['type-tc']}
			/>

			<RangeDropdown options={RANGE_OPTIONS} size="sm" bind:value={params['range-tc']} />
		</Card.Action>
	</Card.Header>

	<Card.Content>
		<MetricLineChart {chains} {chartData} metric={params['type-tc']} />
	</Card.Content>
</Card.Root>
